<template>
  <el-dialog class="dialog-edit-role" :title="title" :visible.sync="visible" width="1000px">
    <ConfigForms ref="form" labelWidth="110px" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';
import { genderTypes } from '../../../config';

// 输出 文本 通过\n分割成数组
const split = (text) => {
  if (!text) return []
  if (typeof text === 'string') return text.split('\n').filter(v => !!v)
  return []
}

// 输入 数组 通过\n转为文本
const join = (texts) => {
  if (!texts) return ''
  if (Array.isArray(texts)) return texts.join('\n')
  return ''
}
// // object转文本
// const keyValueEntry = (obj) => {
//   if (typeof obj === 'object') {
//     let text = ''
//     Object.keys(obj).forEach(key => {
//       text += `${key}:${obj[key]}\n`
//     })
//     return text
//   }
//   return ''
// }
// // 文本转obj
// const keyValueOutput = (text) => {
//   const obj = {}
//   if (typeof text === 'string') {
//     const keyVals = text.split('\n')
//     keyVals.forEach(kv => {
//       const kvs = kv.split(':')
//       if (kvs.length > 1) {
//         obj[kvs[0]] = kvs[1]
//       }
//     })
//   }
//   return obj
// }

const formItems = [
  { type: 'image', label: '头像', required: true, key: 'avatar' }, // 上传图片
  { type: 'text', label: '名称', required: true, key: 'name' },
  { type: 'select', label: '性别', required: true, key: 'gender', options: genderTypes },
  { type: 'images', label: '写真图', required: true, key: 'portrait', width: '100%', contentWidth: '100%' }, // 上传图片
  // { type: 'videos', label: '视频', required: true, key: 'video', width: '100%', contentWidth: '100%' }, // 上传视频
  { type: 'number', label: '年龄', required: true, key: 'age' },
  { type: 'text', label: '职业', required: false, key: 'occupation' },
  { type: 'textarea', label: '首次聊天消息', required: true, key: 'firstChatMessage' },
  { type: 'textarea', label: '个人简介', required: false, key: 'bio' },
  { type: 'textarea', label: '兴趣爱好', placeholder: '多个换行分割', entry: join, output: split, required: false, key: 'hobbies' },
  { type: 'textarea', label: '自定义标签', placeholder: '多个换行分割', entry: join, output: split, required: false, key: 'customTags' },
  { type: 'textarea', label: '个性化设置', placeholder: '键值对形式，换行分割', required: false, key: 'settings' },
  { type: 'text', label: '性格', required: false, key: 'personality' },
  { type: 'text', label: '聊天风格', required: true, key: 'chatStyle' },
  { type: 'switch', label: '是否高级角色', required: true, key: 'isPremium' },
  { type: 'text', label: '当前心情', required: true, key: 'mood' },
  { type: 'text', label: '关系状态', required: false, key: 'relationship' },
  { type: 'text', label: '语音类型', required: false, key: 'voice' },
  { type: 'number', label: '排序', required: false, key: 'sort' },
  { type: 'switch', label: '是否开启', required: false, key: 'status' },
  // { type: 'date', label: '最后活跃时间', required: true, key: 'lastActive' },
  // { type: 'number', label: '点赞次数', required: true, key: 'likeCount' },
  // { type: 'number', label: '解锁次数', required: true, key: 'unlockCount' },
  // { type: 'number', label: '聊天次数', required: true, key: 'chatCount' },
]
export default {
  name: 'EditRole',
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑角色' : '新增角色'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      if (row) {
        this.formData = {}
        this.formItems.forEach(item => {
          this.formData[item.key] = row[item.key]
        })
        // 特殊处理自定义标签
        if (row.customDetailTags) {
          this.formData.customTags = row.customDetailTags.map(v => v.name)
        }
        this.formData.id = row.id
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-role {
  /deep/ .el-date-editor.el-input {
    width: 200px;

  }
}
</style>
